import { Box, Button, Card, CardContent, Divider, Typography, MenuItem, Select, FormControl, InputLabel, Modal } from "@mui/material";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import Header from '../Header/Header';
import { ToastContainer, toast } from "react-toastify";
import consts from "../../constant";
import usercalls from "../../Axios";


const DisputeDetails = () => {

  const path = usercalls();
  const location = useLocation();
  const p2pData = location?.state;
  console.log(p2pData, "p2pDatap2pData");
  const [action, setAction] = useState("");
  const [openImage, setOpenImage] = useState(false);


  const navigate = useNavigate();



  const handleChange = (event) => {
    setAction(event?.target?.value);
  };

  const handleUpdate = async () => {
    if (!action) {
      toast.dismiss();
      toast.error("Please select an action before updating");
      return;
    } else {
      try {

        const payload = {
          updatestatus: action,
          txId: p2pData?.p2pData?.txId
        };


        const url = `${consts?.BackendUrl}/p2p/disputebyadmin`;
        const response = await path.postCall({ url, payload });
        const result = await response.json();

        if (result?.success) {
          toast.success(result?.message);
          setTimeout(() => {
            navigate(`/${consts.route}/raisedispute`);
          }, 2000);

        } else {
          toast.error(result?.message);
        }

      } catch (error) {
        console.log("🚀 ~ getAlUser ~ error", error);
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <Header />
      <Box
        sx={{
          backgroundColor: "#10212c",
          minHeight: "100vh",
          padding: "20px",
          color: "#fff"
        }}>


        <Typography variant="h4" sx={{ color: "#fe7701", marginBottom: "20px", textAlign: "center" }}>
          RAISE DISPUTE QUERY
        </Typography>

        <Button
          variant="outlined"
          sx={{ color: "#fe7701", borderColor: "#fe7701", marginBottom: "20px" }}
          onClick={() => window.history.back()}>

          Back
        </Button>

        <Card sx={{ maxWidth: 600, margin: "auto", backgroundColor: "#1a2b3c", color: "#fff", padding: "20px" }}>
          <CardContent>
            <Typography variant="h6" sx={{ color: "#fe7701" }}>Buyer Info:</Typography>
            <Typography>Name: {p2pData?.buyerName}</Typography>
            <Typography>Email: {p2pData?.buyerEmail}</Typography>

            <Divider sx={{ backgroundColor: "#fe7701", marginY: "10px" }} />

            <Typography variant="h6" sx={{ color: "#fe7701" }}>Seller Info:</Typography>
            <Typography>Name: {p2pData?.sellerName}</Typography>
            <Typography>Email: {p2pData?.sellerEmail}</Typography>

            <Divider sx={{ backgroundColor: "#fe7701", marginY: "10px" }} />

            <Typography variant="h6" sx={{ color: "#fe7701" }}>Order Details:</Typography>
            <Typography>Pair: {p2pData?.p2pData?.coinname}</Typography>
            <Typography>Purchase Price: {p2pData?.p2pData?.price}</Typography>
            <Typography>Purchase Amount: {p2pData?.p2pData?.quantity}</Typography>
            <Typography>Status: Raised a Dispute</Typography>

            <Divider sx={{ backgroundColor: "#fe7701", marginY: "10px" }} />

            <Typography variant="h6" sx={{ color: "#fe7701" }}>Buyer Remarks:</Typography>
            <Typography>Reason: {p2pData?.reason}</Typography>

            <Divider sx={{ backgroundColor: "#fe7701", marginY: "10px" }} />

            {/* <Typography variant="h6" sx={{ color: "#fe7701" }}>Seller Remarks:</Typography>
            <Typography sx={{ color: "red" }}>Seller not raised a dispute yet</Typography> */}

            {/* View Image Button */}
            {p2pData?.img &&
              <Button
                variant="outlined"
                sx={{ color: "#fe7701", borderColor: "#fe7701", marginTop: "15px", width: "100%" }}
                onClick={() => setOpenImage(true)}>

                View Image Proof
              </Button>}


            {/* Image Modal */}
            <Modal open={openImage} onClose={() => setOpenImage(false)}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#fff",
                  padding: "20px",
                  boxShadow: 24,
                  outline: "none",
                  maxWidth: "95vw", // Increased width
                  maxHeight: "95vh", // Increased height
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}>


                <img
                  src={p2pData?.img}
                  alt="Dispute Evidence"
                  style={{
                    width: "100%", // Make it responsive
                    height: "auto", // Maintain aspect ratio
                    maxWidth: "90vw", // Allow it to scale larger
                    maxHeight: "85vh", // Keep it within viewport height
                    borderRadius: "8px"
                  }} />


                <Button
                  variant="contained"
                  sx={{ marginTop: "10px", backgroundColor: "#fe7701", color: "#10212c" }}
                  onClick={() => setOpenImage(false)}>

                  Close
                </Button>
              </Box>
            </Modal>

            {/* Dropdown Select */}
            {
              p2pData?.status == "open" ? (
                <FormControl fullWidth sx={{ marginTop: "15px" }}>
                  <InputLabel sx={{ color: "#fe7701" }}>Select Action</InputLabel>
                  <Select
                    value={action}
                    onChange={handleChange}
                    displayEmpty
                    sx={{
                      backgroundColor: "#1a2b3c",
                      color: "#fe7701", // Text color in dropdown
                      borderColor: "#fe7701",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fe7701" // Border color
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fe7701" // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fe7701" // Border color on focus
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#fe7701" // Dropdown arrow color
                      }
                    }}>


                    <MenuItem value="1"> Cancel </MenuItem>
                    <MenuItem value="0"> Release Asset </MenuItem>
                  </Select>
                </FormControl>) : (<>  <Typography>Status: {p2pData?.p2pData?.status}</Typography>  </>)
            }


            {/* Update Button */}
            {
              p2pData?.status == "open" ? (
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#fe7701", color: "#10212c", marginTop: "15px", width: "100%" }}
                  onClick={handleUpdate}>

                  Update
                </Button>
              ) : null
            }

          </CardContent>
        </Card>
      </Box>
    </>);

};

export default DisputeDetails;